import {
  HRMonthly_EvaluationDetail_GetRow_CONFIRM,
  HRMonthly_EvaluationHead_CONFIRM_STATUS_Update,
  HRMonthly_EvaluationHead_Confirm_Summary,
  HRMonthly_EvaluationHead_POST_CONFIRM,
  HRMonthly_EvaluationRating_List_GetRow_CONFIRM,
  HRMonthly_Evaluation_Update_CONFIRM,
} from "../../Server/ApiV2";

// HR Monthly Evaluation Head Confirm Status Update
export const onGetHRMonthly_EvaluationHead_CONFIRM_STATUS_Update = async (
  postData
) => {
  try {
    const response = await HRMonthly_EvaluationHead_CONFIRM_STATUS_Update(
      postData
    );

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
// HR Monthly Evaluation Head Confirm Summary
export const onGetHRMonthly_EvaluationHead_Confirm_Summary = async (
  postData
) => {
  try {
    const response = await HRMonthly_EvaluationHead_Confirm_Summary(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetHRMonthly_Evaluation_Update_CONFIRM = async (postData) => {
  try {
    const response = await HRMonthly_Evaluation_Update_CONFIRM(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

// HR Monthly Evaluation Head POST
export const onGetHRMonthly_EvaluationHead_POST_CONFIRM = async (postData) => {
  try {
    const response = await HRMonthly_EvaluationHead_POST_CONFIRM(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetHRMonthly_EvaluationDetail_GetRow_CONFIRM = async (
  postData
) => {
  try {
    const response = await HRMonthly_EvaluationDetail_GetRow_CONFIRM(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

export const onGetHRMonthly_EvaluationRating_List_GetRow_CONFIRM = async (
  postData
) => {
  try {
    const response = await HRMonthly_EvaluationRating_List_GetRow_CONFIRM(
      postData
    );

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
